<template>
  <div class="jajajacollapse" id="collapseExamplejajajaja">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <p class="text-primary"><b>I. Datos Personales</b></p>
    <div class="card card-body" style="margin-top: 0">
      <hr />

      <form @submit.prevent="validarCamposEst" style="margin-top: 0" novalidate>
        <div class="row">
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.num_doc') }">
            <input v-model.trim="newEstudiante.num_doc" type="text" class="form-control" placeholder="Documento sin extesion" />
            <small> <span class="text-danger">*</span> Carnet sin extension</small>
            <div class="error" v-if="validation.hasError('newEstudiante.num_doc')">{{ validation.firstError('newEstudiante.num_doc') }}</div>
          </div>
          <div class="col-sm-3">
            <Departamentos showext="true" :model="newEstudiante" :class="{ 'has-error': validation.hasError('newEstudiante.iddepartamento') }" />
            <small> <span class="text-danger">*</span> Departamento(Extension del carnet)</small>
            <div class="error" v-if="validation.hasError('newEstudiante.iddepartamento')">{{ validation.firstError('newEstudiante.iddepartamento') }}</div>
          </div>
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.nombres') }">
            <input v-model.trim="newEstudiante.nombres" type="text" class="form-control" placeholder="Nombres" />
            <small> <span class="text-danger">*</span> Nombres</small>
            <div class="error" v-if="validation.hasError('newEstudiante.nombres')">{{ validation.firstError('newEstudiante.nombres') }}</div>
          </div>
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.pri_apellido') }">
            <input v-model.trim="newEstudiante.pri_apellido" type="text" class="form-control" placeholder="Apellido Paterno" />
            <small> <span class="text-danger">*</span> Apellido paterno</small>
            <div class="error" v-if="validation.hasError('newEstudiante.pri_apellido')">{{ validation.firstError('newEstudiante.pri_apellido') }}</div>
          </div>
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.seg_apellido') }">
            <input v-model.trim="newEstudiante.seg_apellido" type="text" class="form-control" placeholder="Apellido Materno" />
            <small>Apellido Materno</small>
            <div class="error" v-if="validation.hasError('newEstudiante.seg_apellido')">{{ validation.firstError('newEstudiante.seg_apellido') }}</div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-2" :class="{ 'has-error': validation.hasError('newEstudiante.sexo') }">
            <input v-model="newEstudiante.sexo" type="radio" name="sexo" class="checkbox checkbox-inline" value="F" /> F
            <input v-model="newEstudiante.sexo" type="radio" name="sexo" class="checkbox checkbox-inline" value="M" /> M
            <small
              ><br />
              <span class="text-danger">*</span> Sexo</small
            >
            <div class="error text-danger" v-if="validation.hasError('newEstudiante.sexo')">{{ validation.firstError('newEstudiante.sexo') }}</div>
          </div>
          <div class="col-sm-2" :class="{ 'has-error': validation.hasError('newEstudiante.fecha_nac') }">
            <Fecha :model="newEstudiante" :valueto="'fecha_nac'" />
            <small>Fecha de Nacimiento </small>
            <div class="error" v-if="validation.hasError('newEstudiante.fecha_nac')">{{ validation.firstError('newEstudiante.fecha_nac') }}</div>
          </div>
          <div class="col-sm-2" :class="{ 'has-error': validation.hasError('newEstudiante.est_civil') }">
            <input v-model="newEstudiante.est_civil" type="radio" name="ecivil" class="checkbox checkbox-inline" value="S" /> S
            <input v-model="newEstudiante.est_civil" type="radio" name="ecivil" class="checkbox checkbox-inline" value="C" /> C
            <small
              ><br />
              Estado civil</small
            >
            <div class="error" v-if="validation.hasError('newEstudiante.est_civil')">{{ validation.firstError('newEstudiante.est_civil') }}</div>
          </div>
          <div class="col-sm-6" :class="{ 'has-error': validation.hasError('newEstudiante.email') }">
            <input v-model.trim="newEstudiante.email" type="text" class="form-control" placeholder="Correo electronico" />
            <small> <span class="text-danger">*</span> Correo electronico</small>
            <div class="error" v-if="validation.hasError('newEstudiante.email')">{{ validation.firstError('newEstudiante.email') }}</div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-6" :class="{ 'has-error': validation.hasError('newEstudiante.domicilio') }">
            <input v-model.trim="newEstudiante.domicilio" type="text" class="form-control" placeholder="Direccion" />
            <small>Direccion</small>
            <div class="error" v-if="validation.hasError('newEstudiante.domicilio')">{{ validation.firstError('newEstudiante.domicilio') }}</div>
          </div>
          <!-- <div class="col-sm-3">
            <Departamentos showext="true" :model="newEstudiante" :class="{ 'has-error': validation.hasError('newEstudiante.iddepartamento') }" />
            <small> <span class="text-danger">*</span> Departamento(Extension del carnet)</small>
            <div class="error" v-if="validation.hasError('newEstudiante.iddepartamento')">{{ validation.firstError('newEstudiante.iddepartamento') }}</div>
          </div> -->
          <div class="col-sm-3">
            <Ciudades :model="newEstudiante" />
            <small>Ciudad de residencia.</small>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.telefono1') }">
            <input v-model.trim="newEstudiante.telefono1" type="text" class="form-control" placeholder="Telefono movil" />
            <small>Telefono movil</small>
            <div class="error" v-if="validation.hasError('newEstudiante.telefono1')">{{ validation.firstError('newEstudiante.telefono1') }}</div>
          </div>
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.telefono2') }">
            <input v-model.trim="newEstudiante.telefono2" type="text" class="form-control" placeholder="Telefono Fijo" />
            <small>Telefono Fijo</small>
            <div class="error" v-if="validation.hasError('newEstudiante.telefono2')">{{ validation.firstError('newEstudiante.telefono2') }}</div>
          </div>
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.datos_laborales') }">
            <input v-model.trim="newEstudiante.datos_laborales" type="text" class="form-control" placeholder="Persona de contacto" />
            <small>Persona de contacto</small>
            <div class="error" v-if="validation.hasError('newEstudiante.datos_laborales')">{{ validation.firstError('newEstudiante.datos_laborales') }}</div>
          </div>
          <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.contacto') }">
            <input v-model.trim="newEstudiante.contacto" type="text" class="form-control" placeholder="Telefono del contacto" />
            <small>Telefono del contacto</small>
            <div class="error" v-if="validation.hasError('newEstudiante.contacto')">{{ validation.firstError('newEstudiante.contacto') }}</div>
          </div>
        </div>

        <p class="text-primary"><b>II. Datos Academicos</b></p>
        <div class="xcard">
          <div class="row">
            <div class="col-sm-3">
              <Grados :model="newEstudiante" />
              <small>Grado Academico</small>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.profesiones') }">
              <Profesiones :model="newEstudiante" :multiple="true" :valueto="'profesiones'" />
              <small> <span class="text-danger">*</span> Profesion</small>
              <div class="error" v-if="validation.hasError('newEstudiante.profesiones')">{{ validation.firstError('newEstudiante.profesiones') }}</div>
            </div>
            <div class="col-sm-6">
              <Universidades :model="newEstudiante" />
              <small>Universidad de egreso</small>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.usuario_moodle') }">
              <input v-model.trim="newEstudiante.usuario_moodle" type="text" class="form-control" placeholder="Login de moodle" />
              <small> <span class="text-danger">* </span> Usuario Moodle</small>
              <div class="error" v-if="validation.hasError('newEstudiante.usuario_moodle')">{{ validation.firstError('newEstudiante.usuario_moodle') }}</div>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.clave_moodle') }">
              <input v-model.trim="newEstudiante.clave_moodle" type="text" class="form-control" placeholder="Clave de moodle" />
              <small> <span class="text-danger">* </span> Clave Moodle</small>
              <div class="error" v-if="validation.hasError('newEstudiante.clave_moodle')">{{ validation.firstError('newEstudiante.clave_moodle') }}</div>
            </div>
          </div>
        </div>
        <br />
        <p class="text-primary"><b>III. Datos Laborales</b></p>
        <div class="xcard">
          <div class="row">
            <div class="col-sm-6">
              <p>
                <small>Si no encuentra la empresa, seleccione <b>'INDEPENDIENTE'</b></small>
              </p>
              <Empresas :model="newEstudiante" />
              <small>Empresa</small>
            </div>
            <div class="col-sm-6" :class="{ 'has-error': validation.hasError('newEstudiante.cargo') }">
              <p><small>Escriba el cargo del docente en la empresa o institucion de trabajo.</small></p>
              <input v-model.trim="newEstudiante.cargo" type="text" class="form-control" placeholder="Cargo" />
              <small>Cargo</small>
              <div class="error" v-if="validation.hasError('newEstudiante.cargo')">{{ validation.firstError('newEstudiante.cargo') }}</div>
            </div>
          </div>
        </div>
        <Alertas ref="alertar" />
        <p class="text-center">{{ msg }}</p>
        <button class="btn btn-azul" @click="validarCamposEst()">Registrar</button>
      </form>
    </div>
  </div>
</template>


<script>
import Departamentos from '@/components/ADepartamentos.vue';
import Ciudades from '@/components/ACiudades.vue';
import Universidades from '@/components/AUniversidades.vue';
import Profesiones from '@/components/AProfesiones.vue';
// import AEstudianteByDoc from '@/components/AEstudianteByDoc.vue';
import Grados from '@/components/AGrados.vue';
import Empresas from '@/components/AEmpresas.vue';
import Alertas from '@/components/AAlertas.vue';
import Fecha from '@/components/AFecha.vue';
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';

export default {
  props: {
    //inscripcion:{type:Object,required:true},
  },
  data() {
    return {
      activo: true,
      preinscribir: true,
      msg: '',
      programa: {},
      newEstudiante: {
        num_doc: null,
        nombres: null,
        pri_apellido: null,
        email: null,
        sexo: null,
        tipo: 'P',
        diestro: true,
        profesiones: [],

        idempresa: null,
        grados: [],
        idinstitucion: null,
        iddepartamento: null,
        idciudad: null,
        contacto: null,
        domicilio: null,
        datos_laborales: null,
        est_civil: null,
        fecha_nac: null,
        telefono2: null,
        telefono1: null,
        seg_apellido: null,
        usuario_moodle: null,
        clave_moodle: null,

        //este no esta, debe ser concatenado a datos laborales
        cargo: null,
      },
      cuotas: [],
    };
  },
  components: { Ciudades, Universidades, Profesiones, Grados, Empresas, Alertas, Fecha, Departamentos },
  validators: {
    'newEstudiante.num_doc'(value) {
      return Validator.value(value).required().minLength(6).regex('^[1-9]\\d{5,14}(\\-([A-Z0-9]{1,2}))?$');
    },
    'newEstudiante.nombres'(value) {
      return Validator.value(value).required().minLength(3).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.pri_apellido'(value) {
      return Validator.value(value).required().minLength(3).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.email'(value) {
      return Validator.value(value).email().required();
    },
    'newEstudiante.sexo'(value) {
      return Validator.value(value).required();
    },
    'newEstudiante.profesiones'(value) {
      return Validator.value(value).required();
    },
    'newEstudiante.iddepartamento'(value) {
      return Validator.value(value);
    },
    'newEstudiante.usuario_moodle'(value) {
      return Validator.value(value).minLength(4).required();
    },
    'newEstudiante.clave_moodle'(value) {
      return Validator.value(value).minLength(4).required();
    },

    'newEstudiante.telefono1'(value) {
      return Validator.value(value).digit();
    },
    'newEstudiante.telefono2'(value) {
      return Validator.value(value).digit();
    },
    'newEstudiante.seg_apellido'(value) {
      return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.datos_laborales'(value) {
      return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.cargo'(value) {
      return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.contacto'(value) {
      return Validator.value(value).digit();
    },
    'newEstudiante.domicilio'(value) {
      return Validator.value(value).minLength(0).regex('^([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9])([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9 % # ° / : , \' " “ ” - . _ & ()]+)$');
    },
  },
  watch: {
    newEstudiante: {
      deep: true,
      handler(a) {
        if (a == null) return;
        this.$refs.alertar.reset();
        this.msg = '';
        this.preinscribir = true;
        window.sessionStorage.setItem('xnewEstudiante', JSON.stringify(this.newEstudiante));
      },
    },

    'newEstudiante.nombres': function () {
      this.crearLogin();
    },
    'newEstudiante.pri_apellido': function () {
      this.crearLogin();
    },
    'newEstudiante.seg_apellido': function () {
      this.crearLogin();
    },
    'newEstudiante.num_doc': function () {
      this.crearClave();
    },
    'newEstudiante.iddepartamento': function () {
      this.crearClave();
    },
  },
  methods: {
    crearLogin() {
      var a = this.newEstudiante.nombres;
      var ap = this.newEstudiante.pri_apellido;
      var am = this.newEstudiante.seg_apellido;
      var inicial = '';
      var aa = '';
      var mm = '';
      if (a && a.length > 0) {
        inicial = a.substring(0, 1);
      }
      if (ap && ap.length > 0) {
        aa = ap.replace(/\s+/g, '');
      }
      if (am && am.length > 0) {
        mm = am.replace(/\s+/g, '');
      }
      this.newEstudiante.usuario_moodle = inicial + aa + mm;
      this.newEstudiante.usuario_moodle = this.newEstudiante.usuario_moodle.toLowerCase();
    },
    crearClave() {
      var car = this.newEstudiante.num_doc;
      var ci = '';
      var dep = this.newEstudiante.iddepartamento;
      if (car && car.length > 0) ci = this.newEstudiante.num_doc;
      if (dep) ci = ci + this.newEstudiante.iddepartamento.extension;
      this.newEstudiante.clave_moodle = ci;
    },

    validarCamposEst() {
      if (!this.activo) return;
      this.activo = false;
      if( this.newEstudiante.fecha_nac ){
        let d = new Date(this.newEstudiante.fecha_nac);
        let f = new Date().getFullYear();
        if(d.getFullYear() <= 1900 || d.getFullYear() > f){
          this.$refs.alertar.invalido();
          this.activo = true;
          this.$root.$notify.show(`fecha de nacimiento no valida`, {color:'red',x: 'right',});
          return;
        }
      }

      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.newEstudiante);
        if (success) {
          var ids = [];
          obj.profesiones.forEach(function (e) {
            ids.push(e.id);
          });
          delete obj.profesiones;
          obj.profesiones = ids;
          this.simpleValues(obj);
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');

          window.console.log(window.stringifyObject(obj));
          this.$refs.alertar.cargando();
          this.enviarDAtos(obj);
        } else {
          window.console.log(window.stringifyObject(obj));
          this.$refs.alertar.invalido();
          this.activo = true;
        }
      });
    },
    simpleValues(obj) {
      if (obj.idempresa != null) obj.idempresa = obj.idempresa.id;
      if (obj.iddepartamento != null) obj.iddepartamento = obj.iddepartamento.id;
      if (obj.idciudad != null) obj.idciudad = obj.idciudad.id;
      if (obj.iduniversidad != null) obj.idinstitucion = obj.iduniversidad.id;
      if (obj.datos_laborales != null) obj.datos_laborales = obj.cargo + ', ' + obj.datos_laborales;
      if (obj.idgrado != null) {
        obj.grados = [];
        obj.grados.push({ idgrado: obj.idgrado.id, titulo: obj.idgrado.nombre });
      } else obj.datos_laborales = obj.cargo;
      delete obj.iduniversidad;
      delete obj.cargo;
      delete obj.idgrado;
    },
    parseLabel2(option) {
      if (option == null) return '';
      var seg = option.seg_apellido;
      if (seg == null) seg = '';
      return option.nombres + ' ' + option.pri_apellido + ' ' + seg + ' -- Doc: ' + option.num_doc;
    },
    enviarDAtos(obj) {
      var vue = this;
      var sql = gql`mutation{ createPersona(input:${window.stringifyObject(obj)}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
      vue.msg = '';
      window.console.log(sql);

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.createPersona.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('xnewEstudiante', null);
            this.activo = true;
            //var us = data.data.createPersona.persona;
            //vue.inscripcion.idestudiante = { id:us.id,nombre:vue.parseLabel2(us) }
            setTimeout(function () {
              window.$('#collapseExample').collapse('hide');
              window.scrollTop({ top: 0, left: 0, behavior: 'smooth' });
            }, 1000);
            vue.msg = '';
          } else {
            var errores = JSON.stringify(data.data.createPersona.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            vue.msg = '';
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }

          window.console.log(data);
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(JSON.stringify(error));
          this.$notify(parseJsonError(error));
        });
    },
  },
  mounted() {},
};
</script>

<style>
</style>